module.exports = __webpack_public_path__ + "img/symbol_2.44142829.png";